import { HISTORY_TEMPLATES } from "@/lib/constants";
import { HistoryCategory } from "@/lib/types";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { ReactNode } from "react";

const HistoryModal = ({
  category,
  mode,
  onAdd,
  onUpdate,
  isOpen,
  onClose,
  isSubmitting,
  children,
}: {
  category: HistoryCategory;
  mode: "Update" | "Add";
  onAdd: () => void;
  onUpdate: () => void;
  isOpen: boolean;
  onClose: () => void;
  isSubmitting: boolean;
  children: ReactNode;
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight="500" borderBottom="1px solid #E4E4E4">
          {mode} {HISTORY_TEMPLATES[category].title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p="24px 24px 12px 24px">{children}</ModalBody>
        <ModalFooter
          justifyContent="space-between"
          borderTop="1px solid #E4E4E4"
        >
          <Button fontWeight="500" variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          {mode == "Add" ? (
            <Button
              variant="primary"
              fontWeight="500"
              onClick={onAdd}
              isLoading={isSubmitting}
            >
              Add Record
            </Button>
          ) : (
            <Button
              variant="primary"
              fontWeight="500"
              onClick={onUpdate}
              isLoading={isSubmitting}
            >
              Update Record
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default HistoryModal;
